import { useDispatch, useSelector } from 'react-redux';
import { getSignupDataValue, getSignupDataGtkmData } from '../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { EndpointKey } from '../http/EndpointKey';
import { getEndpointRetries, hasEndpointBeenFetched } from '../store/http-responses/selectors';
import { useCurrentStep } from './useCurrentStep';
import { useIsStepDataValid } from './useIsStepDataValid';
import { updateStepOrdersAfterSecondGTKMAPI } from '../http-gtkm-company-info/updateStepOrders';
import { useView } from '../views/useView';
import { Step } from 'signup-constants/Step';
const useHasDomainChanged = () => {
  const companyDomain = useSelector(state => getSignupDataValue(state, Data.CompanyDomain));
  let gtkmCompanyDomain = useSelector(state => getSignupDataGtkmData(state, Data.CompanyDomain));
  if (gtkmCompanyDomain === 'hubspot.com') {
    gtkmCompanyDomain = 'hubspot-test.com';
  }
  return gtkmCompanyDomain !== companyDomain;
};
export const useGTKMDomainSubmit = () => {
  const dispatch = useDispatch();
  const hasDomainChanged = useHasDomainChanged();
  const hasGTKMEndpointBeenFetched = useSelector(state => hasEndpointBeenFetched(state, EndpointKey.GTKMCompanyInfo));
  const {
    currentStep
  } = useCurrentStep();
  const isStepDataValid = useIsStepDataValid(currentStep);
  const gtkmDomain = useSelector(state => getSignupDataGtkmData(state, Data.CompanyDomain));
  const {
    submit
  } = useView({
    stepKey: Step.CompanyDomain
  });
  const gtkmEndpointRetries = useSelector(state => getEndpointRetries(state, EndpointKey.GTKMCompanyInfo));
  const haveNotInvokedSecondGTKMAPI = gtkmEndpointRetries < 1;
  const handleSubmit = () => {
    if (hasDomainChanged && haveNotInvokedSecondGTKMAPI) {
      dispatch(retryEndpoint(EndpointKey.GTKMCompanyInfo));
    } else if (haveNotInvokedSecondGTKMAPI) {
      updateStepOrdersAfterSecondGTKMAPI({
        gtkmData: {
          [Data.CompanyDomain]: gtkmDomain
        },
        dispatch
      });
    } else {
      submit();
    }
  };
  return {
    handleSubmit,
    nextButtonEnabled: isStepDataValid && hasGTKMEndpointBeenFetched
  };
};